import 'bootstrap/dist/css/bootstrap.css'
import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import i18n from './i18n';
import Home from './components/Home.vue'

const routes = [
  { path: '/:id?', component: Home },    
  { path: '/invalid', component: Home }, 
]

const router = createRouter({  
  history: createWebHistory(),
  routes
});

createApp(App)
  .use(router)
  .use(i18n())
  .mount('#app')
import 'bootstrap/dist/js/bootstrap.js'